module.exports = __webpack_public_path__ + "img/sample_cate_01.55322207.png";